module.exports = __webpack_public_path__ + "img/balance_scale.aee3576f.svg";